<template>
  <div>
    <div id="Chart3" style="width: 100%; height: 400px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    myEcharts3() {
      var myChart3 = this.$echarts.init(document.getElementById("Chart3"));
      //配置图表
      var option3 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
        },
        grid: {
          containLabel: true,
          left: 10,
          right: 10,
          bottom: 20,
          top: 30,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "2021-12-09",
            "2021-12-23",
            "2022-01-06",
            "2022-01-20",
            "2022-02-03",
            "2022-01-14",
            "2022-02-02",
            "2022-03-17",
          ],
          offset: 20,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            formatter: function (value) {
              if (value == "2021-12-09") {
                return `{a|${value}}`;
              } else {
                return `{b|${value}}`;
              }
            },
            rich: {
              a: {
                width: 120,
                align: "right",
              },
              b: {
                width: 120,
                align: "left",
              },
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: function (value) {
              return `${value}亿`
            },
          },
          splitLine:{      //y轴 分割线
            lineStyle:{       
              color:'#f7f7f7'
            }
          },
          min:36,
          max:54,
          interval: 2,
        },
        series: [
          {
            name: "剩余份额",
            type: "line",
            smooth: true,
            symbol: "circle",
            showSymbol: false,
            color: "#fcad2a",
            data: [46,41,45,46,48,43,41,39],
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(252,173,42,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(252,173,42,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
              origin: "start",
            },
          },
        ],
      };
      myChart3.setOption(option3);
    },
  },
  mounted() {
    this.myEcharts3();
  },
};
</script>

<style scoped>
</style>